import { RuleAction } from '../enums/POR/RuleAction';
import { RuleOperation } from '../enums/POR/RuleOperation';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';
import { OnPremPortOpeningRequestsTypes } from '../enums/POR/OnPremPortOpeningRequestsTypes';
import { TrafficDirection } from '../enums/POR/TrafficDirection';


export default class PortOpeningRuleOnPrem {
    id!: number;

	type!: OnPremPortOpeningRequestsTypes;

	portOpeningRequestId!: number;

	action!: RuleAction;

	operation!: RuleOperation;

	description!: string;

	sourceIPs!: string;

	sourceObjects!: string;

	sourceEnvironment!: string;

	destinationIPs!: string;

	destinationURLs!: string;

	destinationObjects!: string;

	destinationEnvironment!: string;

	sourcePorts!: string;

	protocol!: string;

	name!: string;

    azureName!: string;

    direction!: PortOpeningRequestsDirection;

	destinationPorts!: string;

	trafficDirection!: TrafficDirection;

	isTemporary!: boolean;

	hasRiskPorts!: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.direction = new PortOpeningRequestsDirection().fromName(obj.direction?.name) ?? (obj.direction != null ? new PortOpeningRequestsDirection().fromValue(obj.direction?.value ?? obj.direction) : undefined);
		this.type = new OnPremPortOpeningRequestsTypes().fromName(obj.type?.name ?? obj.type) ?? (obj.type?.value != null ? new OnPremPortOpeningRequestsTypes().fromValue(obj.type.value) : undefined);
		this.action = new RuleAction().fromName(obj.action?.name) ?? (obj.action != null ? new RuleAction().fromValue(obj.action?.value ?? obj.action) : undefined);
		this.operation = new RuleOperation().fromName(obj.operation?.name) ?? (obj.operation != null ? new RuleOperation().fromValue(obj.operation?.value ?? obj.operation) : undefined);
	}
}